import { css } from '@emotion/react';
import { Box, Typography, styled } from '@mui/joy';
import { Stack } from '@mui/system';

import OrientationIcon from '@/assets/icons/orientation-arrow-black.svg?react';
import SubSignIndicator from '@/assets/icons/sub-sign-indicator.svg?react';
import { SignCodeIcon } from '@/components/signs/SignCodeIcon';
import { I18N_DE } from '@/i18n/de';
import { Sign } from '@/modules/api';

type SignCardProps = {
  sign: Sign;
  subSign: boolean;
  bearing?: number;
};

const SignStack = styled(Stack)(
  () => css`
    padding: 0 36px;
    align-items: center;
  `,
);

const TextBox = styled(Stack)(
  ({ theme }) => css`
    display: flex;
    flex: 1;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    overflow: hidden;
    gap: ${theme.spacing(1)};
  `,
);

const SignHeaderStack = styled(Stack)(
  () => css`
    gap: 8px;
    align-items: center;
    flex-flow: row wrap;

    & p {
      font-size: 1rem;
      font-weight: 700;
    }
  `,
);

const SignFooterStack = styled(Stack)(
  ({ theme }) => css`
    gap: 8px;
    align-items: center;

    & p {
      font-size: 14px;
      font-weight: 400;
      color: ${theme.palette.text.secondary};
    }
  `,
);

export function SignCard({ sign, subSign, bearing }: SignCardProps) {
  return (
    <Stack direction="row" sx={{ width: '100%' }}>
      <SignStack direction="row" gap={subSign ? 1.5 : undefined}>
        {subSign && <SubSignIndicator />}
        <SignCodeIcon
          code={sign.code}
          width={subSign ? 80 : 100}
          height={subSign ? 80 : 100}
          deleted={sign.status === 'DELETED'}
        />
      </SignStack>
      <TextBox>
        <SignHeaderStack direction="row">
          <Stack direction="row" gap={1}>
            {bearing !== undefined && (
              <Box>
                <OrientationIcon
                  style={{
                    transform: `rotate(${bearing}deg)`,
                    width: 20,
                    height: 20,
                  }}
                />
              </Box>
            )}
            <Typography
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: '200px',
              }}
            >
              {sign.code}
            </Typography>
          </Stack>
          <Typography>|</Typography>

          <Typography sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {I18N_DE.SignCategory[sign.category]}
          </Typography>
        </SignHeaderStack>
        <SignFooterStack direction="row">
          <Typography>{`Größe ${sign.size ? I18N_DE.SignSizeShort[sign.size] : '?'}`}</Typography>
          <Typography>|</Typography>
          <Typography>{`${sign.reflectionClass ? I18N_DE.SignReflectionClass[sign.reflectionClass] : 'RA ?'}`}</Typography>
          <Typography>|</Typography>
          <Typography>{`${sign.status ? I18N_DE.SignStatusType[sign.status] : 'Status unbekannt'}`}</Typography>
        </SignFooterStack>
        {/*         <Chip sx={{ fontWeight: 700 }} variant="soft" color="danger" startDecorator={<WarningCircle />}>
          Kritischer Fehler
        </Chip>
        <Chip sx={{ fontWeight: 700 }} variant="soft" color="primary" startDecorator={<ClockIcon />}>
          Verfahren: Entwurf
        </Chip>
        <Chip sx={{ fontWeight: 700 }} variant="soft" color="warning" startDecorator={<GearIcon />}>
          Prüfung: Fehler 12
        </Chip> */}
      </TextBox>
    </Stack>
  );
}
